import { Component } from 'react';
import './styles/accordionItem.scss';

export default class AccordionItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      status: false,
    };
  }

  toggleHandler() {
    this.setState({
      status: !this.state.status
    });
  }

  render() {
    const { title, content, className } = this.props;

    return (
      <div className={`accordion-item ${this.state.status && '_open'} ${className || ''}`}>
        <div className={`accordion-item__title`}>
          <button onClick={this.toggleHandler.bind(this)}>
            <span>{title}</span>
            <img src={require('../../static/images/icons/arrow-down.svg').default} alt="" />
          </button>
        </div>
        <div className={`accordion-item__content`}>
          <div className={`accordion-item__content__text`} dangerouslySetInnerHTML={{__html: content}}></div>
        </div>
      </div>
    );
  }
}
